import Vue from 'vue'
let el = new Vue();

export default (title,type="") => {
    let iconClass = "el-icon-check";
    switch(type) {
        case "err":
            iconClass = "el-icon-circle-close"
        break;
        case "info":
            iconClass = ""
        break;
    }
    el.$notify({
        title,
        duration: 2500,
        iconClass,
        customClass: "notification"
    });
}


// WEBPACK FOOTER //
// ./src/assets/js/hint.js